import { makeStyles } from "@material-ui/core/styles";

export const ResendEmailStyles = makeStyles((theme) => ({
  wrapItemForm: {
      padding: '0 10px'
  },
  icon: {
    fontSize: 150,
    color: theme.palette.white.main,
    margin: theme.spacing(2),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50%',
    backgroundSize: '100% auto',
  },
  textfield: {
    width: '80%',
  },
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    margin: "auto",
    marginBottom: theme.spacing(6)
  },
}));
